class BaseModel {
  set(data) {
    Object.assign(this, data)
    return this
  }
}
export default BaseModel
